/** @format */

import {OverviewCompany} from '../types';

interface SensorCounts {
  triggered: number;
  critical: number | null;
}

export const getSensorCounts = (company: OverviewCompany): SensorCounts => {
  const exclusionSet = new Set(company.sensorExclusions.map(sensor => sensor.sensorName));
  const {red, yellow, gray} = company.sensorGroups;
  const groupedNamesSet = new Set([...red, ...yellow, ...gray]);
  const isGroupingSet = groupedNamesSet.size > 0;
  const redSet = new Set(red);

  const triggered = company.lastChecks.reduce((acc, check) => {
    if (exclusionSet.has(check.sensor.name)) {
      return acc;
    }
    if (isGroupingSet) {
      return groupedNamesSet.has(check.sensor.name) ? acc + check.found : acc;
    }
    return acc + check.found;
  }, 0);

  const critical =
    red.length === 0
      ? null
      : company.lastChecks.reduce((acc, check) => {
          if (exclusionSet.has(check.sensor.name)) {
            return acc;
          }
          return redSet.has(check.sensor.name) ? acc + check.found : acc;
        }, 0);

  return {triggered, critical};
};
